import style from "./Footer.module.css";
import { Link } from "react-router-dom";
import Container from "@/layouts/container/Container";
import Icon from "@/ui/icon/Icon";
import Logo from "@/ui/logo/Logo";

// Import card acceptance logos
import visaLogo from "@/assets/images/payment/acceptance_mark/visa_logo.jpg";
import mastercardLogo from "@/assets/images/payment/acceptance_mark/mc_acc.png";
import maestroLogo from "@/assets/images/payment/acceptance_mark/ms_acc.png";
import raiffeisenLogo from "@/assets/images/payment/acceptance_mark/raiffeisen_bank.png";
import amexLogo from "@/assets/images/payment/acceptance_mark/AmericanExpress.jpg";
import dinersLogo from "@/assets/images/payment/acceptance_mark/Diners.gif";
import discoverLogo from "@/assets/images/payment/acceptance_mark/Discover.png";

function Footer() {
	return (
		<div className={style.footer}>
			<Container>
				<div className={style.content}>
					<div className={style.mainSection}>
						<div className={style.leftSection}>
							<div className={style.logoWrapper}>
								<Logo />
							</div>

							<div className={style.contactInfo}>
								{/* <h5>O kompaniji:</h5>
								<div className={style.contactItem}>
									<Icon
										icon="fa-location-dot"
										className={style.contactIcon}
									/>
									<span>Sarajevo, Bosna i Hercegovina</span>
								</div>
								<div className={style.contactItem}>
									<Icon
										icon="fa-envelope"
										className={style.contactIcon}
									/>
									<span>E-mail: mentoriosedu@gmail.com</span>
								</div> */}
								<div className={style.footerColumn}>
									<h5>Društvene mreže</h5>
									<div className={style.socialLinks}>
										<a
											href="https://www.instagram.com/mentoriosedu"
											target="_blank"
											rel="noopener noreferrer"
											className={style.socialIcon}
										>
											<Icon
												icon="fa-instagram"
												iconType="fa-brands"
											/>
										</a>
										<a
											href="https://www.facebook.com/edumentorios"
											target="_blank"
											rel="noopener noreferrer"
											className={style.socialIcon}
										>
											<Icon
												icon="fa-facebook"
												iconType="fa-brands"
											/>
										</a>
										<a
											href="https://www.tiktok.com/@mentoriosedu"
											target="_blank"
											rel="noopener noreferrer"
											className={style.socialIcon}
										>
											<Icon
												icon="fa-tiktok"
												iconType="fa-brands"
											/>
										</a>
									</div>
								</div>
							</div>
						</div>

						<div className={style.rightSection}>
							<div className={style.footerColumn}>
								<h5>Linkovi</h5>
								<ul>
									<li>
										<Link to="/impressum">Impresum</Link>
									</li>
									<li>
										<Link to="/privacy-policy">
											Politika privatnosti
										</Link>
									</li>
									<li>
										<Link to="/terms-and-conditions">
											Uslovi korištenja
										</Link>
									</li>
									<li>
										<Link to="/support">Zatraži pomoć</Link>
									</li>
								</ul>
							</div>

							{/* <div className={style.footerColumn}>
								<h5>Društvene mreže</h5>
								<div className={style.socialLinks}>
									<a
										href="https://www.instagram.com/mentoriosedu"
										target="_blank"
										rel="noopener noreferrer"
										className={style.socialIcon}
									>
										<Icon
											icon="fa-instagram"
											iconType="fa-brands"
										/>
									</a>
									<a
										href="https://www.facebook.com/MentoriosEdu"
										target="_blank"
										rel="noopener noreferrer"
										className={style.socialIcon}
									>
										<Icon
											icon="fa-facebook"
											iconType="fa-brands"
										/>
									</a>
									<a
										href="https://www.tiktok.com/@mentoriosedu"
										target="_blank"
										rel="noopener noreferrer"
										className={style.socialIcon}
									>
										<Icon
											icon="fa-tiktok"
											iconType="fa-brands"
										/>
									</a>
								</div>
							</div> */}
						</div>
					</div>

					<div className={style.bottomSection}>
						<div className={style.copyright}>
							© Mentorios {new Date().getFullYear()}. Sva prava
							zadržana.
						</div>

						<div className={style.cardLogos}>
							<a
								href="https://www.visa.com"
								target="_blank"
								rel="noopener noreferrer"
								className={style.cardLogo}
							>
								<img src={visaLogo} alt="Visa" />
							</a>
							<a
								href="https://www.mastercard.com"
								target="_blank"
								rel="noopener noreferrer"
								className={style.cardLogo}
							>
								<img src={mastercardLogo} alt="Mastercard®" />
							</a>
							<a
								href="https://brand.mastercard.com/brandcenter/more-about-our-brands.html"
								target="_blank"
								rel="noopener noreferrer"
								className={style.cardLogo}
							>
								<img src={maestroLogo} alt="Maestro®" />
							</a>
							<a
								href="https://www.raiffeisenbank.ba/bs/"
								target="_blank"
								rel="noopener noreferrer"
								className={style.cardLogo}
							>
								<img src={raiffeisenLogo} alt="Raiffeisen®" />
							</a>
						</div>
					</div>
				</div>
			</Container>
		</div>
	);
}

export default Footer;
